import React from "react"
import PropTypes from "prop-types"

export function Loading(props) {
  if (props.loading) {
    return props.renderLoading()
  }

  if (props.error) {
    return props.renderError(props.error)
  }

  return props.children()
}

Loading.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.any,
  children: PropTypes.func.isRequired,
  renderLoading: PropTypes.func.isRequired,
  renderError: PropTypes.func.isRequired,
}

Loading.defaultProps = {
  renderLoading: () => <div>Loading...</div>,
  renderError: error => <div>Error {error}</div>,
}

export default Loading
